import { Component, Host, h, Prop, Event, State, Element } from '@stencil/core'
import type { EventEmitter } from '@stencil/core'

import type { PageConfig } from '../../../../config/page-configs/page-configs'
import type { BotId } from '../../../../global/models/models'

@Component({
    tag: 'c-header',
    styleUrl: 'c-header.scss',
})
export class CHeader {
    closeButtonElement: HTMLButtonElement
    @Element() el: HTMLElement
    @Prop() pageConfig: PageConfig
    @Prop() isWelcomeScreen: boolean
    @Prop() botId?: BotId
    @Prop() isLocal?: boolean = false
    @Event() restart: EventEmitter
    @Event() close: EventEmitter

    @State() isOpen: boolean = false

    render() {
        return (
            <Host id="cb-header" class={this.isWelcomeScreen ? 'glow-unset' : 'glow-inset'}>
                <c-avatar-bot variant="conversation" role="text" aria-label="Chatbot Avatar"></c-avatar-bot>
                <h2>{this.pageConfig.header}</h2>
                <span class="buttons-container">
                    {this.isLocal && this.botId === 'SAS' && !this.isWelcomeScreen && <c-menu isOpen={this.isOpen}></c-menu>}
                    <button
                        id="cb-minimize-button"
                        class="minimize-bot"
                        title="Minimieren"
                        aria-label="Minimieren"
                        onClick={this.close.emit}
                        ref={(el) => (this.closeButtonElement = el!)}
                        data-analytics-track="true"
                        data-analytics-action="ButtonClicks TCB: Klick"
                        data-analytics-value="Minimize"
                        data-analytics-name="TCB: Header Button"
                        data-analytics-category="TCB | ButtonClicks"
                    >
                        <i
                            class="ba-icon ba-icon-minus"
                            data-analytics-track="true"
                            data-analytics-action="ButtonClicks TCB: Klick"
                            data-analytics-value="Minimize"
                            data-analytics-name="TCB: Header Button"
                            data-analytics-category="TCB | ButtonClicks"
                        />
                    </button>
                    {!this.isWelcomeScreen && (
                        <button
                            id="cb-restart-button"
                            class="restart-bot"
                            title="Neu starten"
                            aria-label="Neu starten"
                            onClick={this.restart.emit}
                            data-analytics-track="true"
                            data-analytics-action="ButtonClicks TCB: Klick"
                            data-analytics-value="Reload Chatbot"
                            data-analytics-name="TCB: Header Button"
                            data-analytics-category="TCB | ButtonClicks"
                        >
                            <i
                                class="ba-icon ba-icon-repeat"
                                data-analytics-track="true"
                                data-analytics-action="ButtonClicks TCB: Klick"
                                data-analytics-value="Reload Chatbot"
                                data-analytics-name="TCB: Header Button"
                                data-analytics-category="TCB | ButtonClicks"
                            />
                        </button>
                    )}
                    <button
                        id="cb-close-button"
                        class="close-bot"
                        title="Schließen"
                        aria-label="Schließen"
                        onClick={this.close.emit}
                        ref={(el) => (this.closeButtonElement = el!)}
                        data-analytics-track="true"
                        data-analytics-action="ButtonClicks TCB: Klick"
                        data-analytics-value="Close"
                        data-analytics-name="TCB: Header Button"
                        data-analytics-category="TCB | ButtonClicks"
                    >
                        <i
                            class="ba-icon ba-icon-x"
                            data-analytics-track="true"
                            data-analytics-action="ButtonClicks TCB: Klick"
                            data-analytics-value="Close"
                            data-analytics-name="TCB: Header Button"
                            data-analytics-category="TCB | ButtonClicks"
                        />
                    </button>
                </span>
            </Host>
        )
    }
}
